import type { RuntimeScreenResponse } from '@boox/contracts';
import { getRuntimeScreen } from '@/lib/runtime-api';
import type { PageContext } from '@/stores/chat-context-store';

function detectQuestionLanguage(input: string): string | undefined {
  const trimmed = input.trim();
  if (!trimmed) return undefined;
  if (/[\u4e00-\u9fff]/.test(trimmed)) return 'zh';
  if (/[ぁ-んァ-ン]/.test(trimmed)) return 'ja';
  if (/[ก-๙]/.test(trimmed)) return 'th';
  return 'en';
}

function resolveRuntimeRoute(pageContext: PageContext): string {
  if (typeof window !== 'undefined') {
    if (window.location.pathname.startsWith('/wm')) return window.location.pathname;
    if (window.location.pathname.startsWith('/wms')) return window.location.pathname.replace(/^\/wms/, '/wm');
  }

  const page = pageContext.pageKey.split('.')[1] ?? 'dashboard';
  return page === 'dashboard' ? '/wm' : `/wm/${page}`;
}

export async function resolveDynamicRuntimeChatContext(params: {
  pageContext: PageContext;
  question: string;
}): Promise<RuntimeScreenResponse | undefined> {
  if (params.pageContext.module !== 'wms') return undefined;

  try {
    return await getRuntimeScreen({
      surface: 'web',
      module: params.pageContext.module,
      route: resolveRuntimeRoute(params.pageContext),
      entityType: params.pageContext.entityType,
      entityId: params.pageContext.entityId,
      questionLanguage: detectQuestionLanguage(params.question),
    });
  } catch {
    return undefined;
  }
}
